import './App.css';
import PortfolioApp from './components/PortfolioApp';

function App() {
  return (
    <PortfolioApp /> 
  );
}

export default App;
